import React, { useState } from 'react';
import { Calendar, Clock, MapPin } from 'lucide-react';
import { useStore, getUpcoming, getHistory, cancelAppointment } from '../lib/store';
export function MyAppointments() {
  const [tab, setTab] = useState<'upcoming' | 'history'>('upcoming');
  const {
    appointments
  } = useStore();
  const upcoming = getUpcoming(appointments);
  const history = getHistory(appointments);
  const list = tab === 'upcoming' ? upcoming : history;
  return <div className="px-6 pt-12 pb-6 space-y-6 flex flex-col h-full" data-id="element-943">
      <h2 className="text-2xl font-semibold text-light" data-id="element-944">Mis Turnos</h2>

      <div className="flex bg-dark-card p-1 rounded-xl border border-white/5" data-id="element-945">
        <button onClick={() => setTab('upcoming')} className={`flex-1 py-2 text-sm font-medium rounded-lg transition-colors ${tab === 'upcoming' ? 'bg-dark text-light shadow' : 'text-light-muted'}`} data-id="element-946">
          Próximos
        </button>
        <button onClick={() => setTab('history')} className={`flex-1 py-2 text-sm font-medium rounded-lg transition-colors ${tab === 'history' ? 'bg-dark text-light shadow' : 'text-light-muted'}`} data-id="element-947">
          Historial
        </button>
      </div>

      <div className="flex-1 space-y-4" data-id="element-948">
        {list.length === 0 ? <div className="text-center py-12 text-light-muted" data-id="element-949">
            <Calendar size={48} className="mx-auto mb-4 opacity-20" data-id="element-950" />
            <p data-id="element-951">
              No tenés turnos{' '}
              {tab === 'upcoming' ? 'próximos' : 'en el historial'}.
            </p>
          </div> : list.map(a => <div key={a.id} className="bg-dark-card rounded-2xl p-5 border border-white/5 space-y-4" data-id="element-952">
              <div className="flex justify-between items-start" data-id="element-953">
                <div data-id="element-954">
                  <p className="text-xs text-gold font-medium mb-1" data-id="element-955">
                    {new Date(a.date).toLocaleDateString('es-AR', {
                weekday: 'long',
                day: 'numeric',
                month: 'long'
              })}
                  </p>
                  <h3 className="text-lg font-medium text-light" data-id="element-956">
                    {a.time} hs
                  </h3>
                </div>
                <span className={`px-2.5 py-1 rounded-md text-[10px] font-medium uppercase ${a.status === 'cancelled' ? 'bg-red-500/10 text-red-400' : a.status === 'completed' ? 'bg-green-500/10 text-green-400' : 'bg-gold/10 text-gold'}`} data-id="element-957">
                  {a.status === 'upcoming' ? 'Confirmado' : a.status === 'completed' ? 'Completado' : 'Cancelado'}
                </span>
              </div>
              <div className="flex items-center gap-3 bg-dark p-3 rounded-xl border border-white/5" data-id="element-958">
                <img src={a.barberImage} alt={a.barberName} className="w-10 h-10 rounded-full object-cover" data-id="element-959" />
                <div data-id="element-960">
                  <p className="text-sm font-medium text-light" data-id="element-961">
                    {a.barberName}
                  </p>
                  <p className="text-[10px] text-light-muted" data-id="element-962">
                    {a.serviceName}
                  </p>
                </div>
              </div>
              {tab === 'upcoming' && <div className="flex gap-2 pt-2" data-id="element-963">
                  <button onClick={() => cancelAppointment(a.id)} className="flex-1 py-2.5 border border-white/10 text-light rounded-xl text-xs font-medium hover:bg-white/5 transition-colors" data-id="element-964">
                    Cancelar
                  </button>
                  <button className="flex-1 py-2.5 bg-white/5 text-light rounded-xl text-xs font-medium hover:bg-white/10 transition-colors" data-id="element-965">
                    Reagendar
                  </button>
                </div>}
            </div>)}
      </div>
    </div>;
}